export default __webpack_public_path__ + "static/media/WS_Logo_SBL_Central.12e5356f.jpg";